import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useDisciplineFilesStore, DISCIPLINE_FILES_ARRAY_QUERY_KEYS, getCanonicalDisciplineFilesQuery, queryToDisciplineFilesFilters } from '@pages/discipline'
import { useListsStore } from '@shared/model'
import { MAX_PER_PAGE, toPaginationValue } from '@shared/lib/routes'
import { foldBracketArrayParams } from '@shared/lib/url'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

/** `/disciplines/{id}/files` — query → store filters, as `middleware/surveys.ts` does. */
export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalizedGeneric) => {
  const foldedQuery = foldBracketArrayParams(to.query, DISCIPLINE_FILES_ARRAY_QUERY_KEYS)
  const query = foldedQuery ?? to.query

  const lists = await useListsStore().ensure()
  const filters = queryToDisciplineFilesFilters(query, lists?.file ?? null)
  const canonicalQuery = getCanonicalDisciplineFilesQuery(query, filters)

  if (foldedQuery || canonicalQuery) {
    return navigateTo({ path: to.path, query: canonicalQuery ?? query, hash: to.hash }, { replace: true })
  }

  const store = useDisciplineFilesStore()

  store.setFilters(filters)
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
  store.closeModal()
})
